import * as React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core"
import { forwardRef } from "react";


export const TsPromoVideoIcon: React.FC<SvgIconProps> = forwardRef(({...props}, ref) => {
  return (
    <SvgIcon {...props} viewBox="40 20 64 64" innerRef={ref}>
      <rect x="40" y="20" width="64" height="64" rx="8" fill="#5667F6"/>
      <path d="M56 36L60 44H66L62 36H66L70 44H76L72 36H76L80 44H86L82 36H88C89.1 36 90.0417 36.3917 90.825 37.175C91.6083 37.9583 92 38.9 92 40V64C92 65.1 91.6083 66.0417 90.825 66.825C90.0417 67.6083 89.1 68 88 68H56C54.9 68 53.9583 67.6083 53.175 66.825C52.3917 66.0417 52 65.1 52 64V40C52 38.9 52.3917 37.9583 53.175 37.175C53.9583 36.3917 54.9 36 56 36ZM56 48V64H88V48H56Z" fill="#F8F8F8"/>
    </SvgIcon>
  );
})

export default TsPromoVideoIcon;